module.exports = __webpack_public_path__ + "static/img/electric.467788e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/energy/electric.png
// module id = ntmz
// module chunks = 3